import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActiveserviceService } from 'src/app/Services/ActiveUsers/activeservice.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExoStar } from 'src/app/models/ExoStar';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { ToastrService } from 'ngx-toastr';
import { ExoStarService } from 'src/app/Services/ExoStar/exo-star.service';
import { ILogicalAudit } from 'src/app/models/ilogical-audit';
import { MessagesService } from 'src/app/Services/Messages/messages.service';
import { IMessagingReceived, IMessagingSender, IMessaging } from 'src/app/models/IMessaging';
import { Defaults } from 'src/app/Utilities/defaults';

export interface DialogData {
  associateUser: string;
  role: boolean;
  senderId: any;
  screen: string;
  adminUser: string;
  keychk: boolean;
  receiverid: string;

}

@Component({
  selector: 'app-initiate-revoke',
  templateUrl: './initiate-revoke.component.html',
  styleUrls: ['./initiate-revoke.component.css']
})
export class InitiateRevokeComponent implements OnInit {
  InitiateRevokeform: FormGroup;
  submitted = false;
  Keys: ExoStar[];
  public chkGrantacess: boolean;
  public chkDeaVald: boolean;
  licensekeydisableBtn: boolean = false;
  public AdminList: IUserDetails[];
  public userId: string;
  public senderId: any;
  public adminUser: string
  public screen: string;
  IsAdmin: boolean = false;
  public associteUser: ExoStar;
  public auditLog: ILogicalAudit;
  isInitiatebtn: boolean = false;
  isIntermediate: boolean = false;
  isApprove: boolean = false;
  isEPCSDisable: boolean = false;
  isLICDisable: boolean = false;
  public chkkeys: boolean;
  isDropDownkeyDisable: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<InitiateRevokeComponent>, private formBuilder: FormBuilder, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private activeserviceService: ActiveserviceService, private sharedService: SharedService, private ExoStarServices: ExoStarService, private messageService: MessagesService) {
    this.userId = data.associateUser;
    this.IsAdmin = data.role;
    this.senderId = data.senderId;
    this.screen = data.screen;
    this.adminUser = data.adminUser;
    this.chkkeys = data.keychk;
    this.getLicenseKeys();
    this.getAllAdmins()

    // this.getAssociateUserDetails(this.userId);
    if (this.screen == 'EPCS') {
      if (this.chkkeys == true) {
        this.isLICDisable = true;
        this.isInitiatebtn = true;
      } else {
        this.isLICDisable = false;
        this.isInitiatebtn = true;
      }
      // this.isInitiatebtn = true;
      // this.isLICDisable = true;
    } else if (this.screen == 'Final') {
      this.isApprove = true;
    } else if (this.screen == 'Intermediate') {
      this.isIntermediate = true;
      this.isEPCSDisable = true;
      this.isLICDisable = true;
    }
    // else if(this.screen == "Dashboard"){
    //   this.isEPCSDisable = true;
    //   this.isLICDisable = true;
    // }
  }

  ngOnInit() {
    this.InitiateRevokeform = this.formBuilder.group({
      ProviderName: ['',],
      licensekeys: ['', [Validators.required]],
      providerid: [''],
      npinumber: [''],
      dea: [''],
      epcsadmin: ['', [Validators.required]],
    });
    this.getAssociateUserDetails(this.userId);
    //this.getLicenseKeys();
    //this.getAllAdmins()
    //this.fetchdata();
    this.InitiateRevokeform.markAllAsTouched();
    this.InitiateRevokeform.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.InitiateRevokeform);

    });
  }
  getAllAdmins() {
    this.sharedService.getPracticeManagers(this.adminUser).subscribe(data => {
      this.AdminList = data;
    });
  }
  getLicenseKeys() {
    this.activeserviceService.getLicenseKeys().subscribe(result => {
      this.Keys = result;
    });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  fetchdata() {
    this.InitiateRevokeform.patchValue({
      ProviderName: this.associteUser.providerName,
      npinumber: this.associteUser.NPI,
      providerid: this.associteUser.providerId,
      licensekeys: Number(this.associteUser.licenseKey),
      epcsadmin: this.associteUser.revokeAdminUser,
      dea: this.associteUser.DEA
    });
  }
  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  onSubmit() {
    var EpseObj: ExoStar = this.InitiateRevokeform.value;
    EpseObj.adminUserId = this.InitiateRevokeform.value.epcsadmin;
    if (this.IsAdmin == true) {
      EpseObj.grantAccess = false;
    } else {
      EpseObj.grantAccess = true;
    }
    if (EpseObj != null && EpseObj != undefined) {
      EpseObj.modifiedBy = sessionStorage.getItem("userId").toString();
      EpseObj.userId = this.userId;
      if (this.screen == "EPCS" && this.IsAdmin == true)
        this.sendRequestMessage();
      else if (this.screen == "EPCS" && this.IsAdmin == false)
        this.sendIntermediateMessage();
      else if (this.screen == "Dashboard")
        this.sendResponseMessage();
      else {
        this.auditLog = new ILogicalAudit();
        this.auditLog.AdminId = this.associteUser.adminUserId;
        this.auditLog.providerId = this.userId;
        this.auditLog.msgType = 'GRANT ACCESS';
        this.auditLog.grantAccess = true;
        this.auditLog.facilityId = Number(sessionStorage.getItem("FacilityId"));
        this.auditLog.locationId = Number(sessionStorage.getItem("LocationId"));
        this.updateAuditLog();
      }
      this.dialogRef.close(EpseObj);

    } else {
      this.toastr.warning("Please Select License Key");
      return;
    }
  }
  formErrors = {
    'epcsadmin': '',
    'licensekeys': '',
  };

  validationMessages = {
    'epcsadmin': {
      'required': 'epcsadmin Key is required.',
    },
    'licensekeys': {
      'required': 'licensekeys is required.'
    },
  };
  logValidationErrors(group: FormGroup = this.InitiateRevokeform): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid
          && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

  getAssociateUserDetails(userId: any) {
    this.ExoStarServices.getExoStarAssociateDetails(userId).subscribe(
      results => {
        this.associteUser = results;
        this.fetchdata();
      }, (err: any) => {
        console.log(err);
      });
  }
  updateAuditLog() {
    //  update this.auditLog
    this.ExoStarServices.insertErxAuditLogDetails(this.auditLog).subscribe(
      results => {
      }, (err: any) => {
        console.log(err);
      });

  }


  onUserChange() {
    var user = this.AdminList.find(x => x.userId == this.InitiateRevokeform.value.epcsadmin);
    if (user.roleName == 'ADMIN')
      this.IsAdmin = true;
    else
      this.IsAdmin = false;
  }

  msgsender: IMessagingSender;
  messaging: IMessaging = new IMessaging;
  msgreceived: IMessagingReceived[] = [];
  roleId: any;
  msgSenderId: any;
  msgReceiverId: any;
  sendRequestMessage() {
    this.MapValuesforSender('REQUEST');
    this.MapValuesforReceiver(this.userId);
    this.InsertMessage();
    // insert logical access
    this.updateAuditLog();

    // update revoke details
    this.initiateRevoke();
  }
  sendIntermediateMessage() {
    this.MapValuesforSender('INTERMREQUEST');
    this.MapValuesforReceiver(this.InitiateRevokeform.value.epcsadmin);
    this.InsertMessage();
    // insert logical access
    this.updateAuditLog();

    // update revoke details
    this.initiateRevoke();
  }
  sendResponseMessage() {
    this.MapValuesforSender('RESPONSE');
    this.MapValuesforReceiver(this.userId);
    this.InsertMessage();
    // insert logical access
    this.updateAuditLog();

    // update revoke details
    this.initiateRevoke();

  }

  MapValuesforSender(requestType: any) {
    this.msgsender = new IMessagingSender();
    this.msgsender.senderId = 0;
    if (requestType == 'REQUEST') {
      this.msgsender.senderUserID = sessionStorage.getItem("userId");
      this.msgsender.receiverUserID = this.userId;
      // this.msgsender.listUsersTo = this.licensekeyform.value.epcsadmin;
      // this.msgsender.patName =  this.name; // get userid into this popup 
      this.msgsender.subject = 'REVOKE REQUEST'; //associate user
      this.msgsender.body = 'REVOKE REQUEST';
      this.msgsender.messageType = Defaults.message_Type_revoke;
      this.auditLog = new ILogicalAudit();
      this.auditLog.AdminId = this.InitiateRevokeform.value.epcsadmin;
      this.auditLog.providerId = this.userId;
      this.auditLog.msgType = 'REVOKE ACCESS';
      this.auditLog.grantAccess = true;
      this.auditLog.facilityId = Number(sessionStorage.getItem("FacilityId"));
      this.auditLog.locationId = Number(sessionStorage.getItem("LocationId"));

    }
    else if (requestType == 'INTERMREQUEST') {
      this.msgsender.senderUserID = sessionStorage.getItem("userId");
      this.msgsender.receiverUserID = this.InitiateRevokeform.value.epcsadmin;
      this.msgsender.subject = this.userId; //associate user
      this.msgsender.body = 'REVOKE REQUEST';
      this.msgsender.messageType = Defaults.message_Type_revoke;
      this.auditLog = new ILogicalAudit();
      this.auditLog.AdminId = sessionStorage.getItem("userId");
      this.auditLog.providerId = this.InitiateRevokeform.value.epcsadmin;
      this.auditLog.msgType = 'REVOKE ACCESS';
      this.auditLog.grantAccess = true;
      this.auditLog.facilityId = Number(sessionStorage.getItem("FacilityId"));
      this.auditLog.locationId = Number(sessionStorage.getItem("LocationId"));
    }
    else {
      this.msgsender.subject = this.associteUser.adminUserId;
      this.msgsender.body = 'REVOKE ACCESS';
      this.msgsender.senderUserID = this.associteUser.adminUserId;
      this.msgsender.messageType = Defaults.message_Type_finalizeGrant;
      this.msgsender.receiverUserID = this.userId;
      this.auditLog = new ILogicalAudit();
      this.auditLog.AdminId = this.associteUser.adminUserId;
      this.auditLog.providerId = this.userId;
      this.auditLog.msgType = 'REVOKE ACCESS';
      this.auditLog.grantAccess = true;
      this.auditLog.facilityId = Number(sessionStorage.getItem("FacilityId"));
      this.auditLog.locationId = Number(sessionStorage.getItem("LocationId"));
    }

    this.msgsender.isDeleted = false;
    this.msgsender.isVisible = false;
    this.msgsender.dbOpertion = "Insert";
    this.msgsender.createdBy = sessionStorage.getItem("userId");
    this.msgsender.createdOn = new Date;
    this.msgsender.messageName = "";
    this.msgsender.imageSource = "";
    this.msgsender.amendmentId = 0;
    this.msgsender.amendmentStatus = "";
    this.msgsender.attachmentName = "";
    this.msgsender.attachment = "";
    this.msgsender.listUsersCC = "";
    this.msgsender.toOrCC = "";

  }

  msgreceiver: IMessagingReceived;
  MapValuesforReceiver(receiver: any) {
    this.msgreceiver = new IMessagingReceived;
    this.msgreceiver.listUsersTo = receiver;
    this.msgreceiver.receiverUserID = receiver;
    this.msgreceiver.receiverID = 0;
    this.msgreceiver.senderID = 0;
    this.msgreceiver.listUsersCC = "";
    this.msgreceiver.toOrCC = "";
    this.msgreceiver.roleID = this.roleId;
    this.msgreceiver.dbOpertion = "Insert";
    this.msgreceiver.isActive = false;
    this.msgreceiver.isVisible = false;
    this.msgreceiver.isDeleted = false;
    this.msgreceiver.createdBy = sessionStorage.getItem("userId");
    this.msgreceiver.createdOn = new Date;
    this.msgreceiver.attachmentName = "";
    this.msgreceiver.attachment = "";
    this.msgreceived.push(this.msgreceiver);
    this.msgreceiver = null;
  }

  result: string = "";
  InsertMessage() {
    this.messaging.messagingSenders = this.msgsender;
    this.messaging.lstmessagingReceiveds = this.msgreceived;
    this.messageService.insertSenderMessageDetails(this.messaging, sessionStorage.getItem("userId")).subscribe(data => {
      this.result = data;
      this.toastr.success(this.result);
    },
      (err: any) => {
        console.log(err)
        this.result = err;
        this.toastr.error(this.result);
      }
    );
  }

  initiateRevoke() {
    this.ExoStarServices.InitiateRevoke(this.userId, this.InitiateRevokeform.value.epcsadmin, false).subscribe(
      results => {
      }, (err: any) => {
        console.log(err);
      });

  }

  onApprove() {
    this.auditLog = new ILogicalAudit();
    this.auditLog.AdminId = this.userId;   //this.associteUser.adminUserId;
    this.auditLog.providerId = this.userId;
    this.auditLog.msgType = 'FINALIZE REVOKE ACCESS';
    this.auditLog.grantAccess = true;
    this.auditLog.facilityId = Number(sessionStorage.getItem("FacilityId"));
    this.auditLog.locationId = Number(sessionStorage.getItem("LocationId"));
    this.updateAuditLog();
    // update message
    this.updateMessageStatus();
    // revoke complete access
    this.finalizeRevoke();
  }

  updateMessageStatus() {
    this.ExoStarServices.UpdateMessingSendbyId(this.senderId).subscribe(
      results => {
        this.dialogRef.close();
      }, (err: any) => {
        console.log(err);
      });

  }

  finalizeRevoke() {
    this.ExoStarServices.finalizeRevoke(this.userId).subscribe(
      results => {
        this.dialogRef.close();
      }, (err: any) => {
        console.log(err);
      });
  }


  onIntermediateApprove() {
    // send message to dea registrant
    if (this.data.receiverid != this.associteUser.revokeAdminUser && this.screen == "Intermediate") {
      this.toastr.error("Processed by some other user");
      this.updateMessageStatus();
      this.dialogRef.close();
    }
    else {
      this.msgsender = new IMessagingSender();
      this.msgsender.senderId = 0;
      this.msgsender.senderUserID = this.InitiateRevokeform.value.epcsadmin;
      this.msgsender.receiverUserID = this.userId;
      this.msgsender.subject = 'REVOKE REQUEST'; //associate user
      this.msgsender.body = 'REVOKE REQUEST';
      this.msgsender.messageType = Defaults.message_Type_revoke;
      this.msgsender.createdBy = sessionStorage.getItem("userId");
      this.msgsender.createdOn = new Date();

      this.MapValuesforReceiver(this.userId);

      this.InsertMessage();

      // logical audit
      this.auditLog = new ILogicalAudit();
      this.auditLog.AdminId = this.InitiateRevokeform.value.epcsadmin;
      this.auditLog.providerId = this.userId;
      this.auditLog.msgType = 'REVOKE ACCESS';
      this.auditLog.grantAccess = true;
      this.auditLog.facilityId = Number(sessionStorage.getItem("FacilityId"));
      this.auditLog.locationId = Number(sessionStorage.getItem("LocationId"));
      this.updateAuditLog();

      // update message
      this.updateMessageStatus();
    }

  }
}